import { Outlet, RouteObject } from 'react-router-dom';
import React from 'react';
import { PROFILE_ROUTE, PUBLIC_PROFILE_ROUTE } from './route.definitions';
import { ProfilePage, OtherUserProfilePage } from './page';
import { BhabiAppLayout } from '../components';

export const profileRoutes = (
  el: JSX.Element = <ProfilePage />
): RouteObject => ({
  path: PROFILE_ROUTE.ABSOLUTE_PATH,
  element: (
    <BhabiAppLayout>
      <Outlet />
    </BhabiAppLayout>
  ),
  children: [
    {
      index: true,
      element: el,
    },
    {
      path: PUBLIC_PROFILE_ROUTE.KEY,
      element: <OtherUserProfilePage />,
    },
  ],
});
